import { OverlayType } from '../../constants/common'
import BaseConfig from './overlayBaseConfig'

export type Options = { period: number; fromStart?: boolean }

export interface Attrs extends Omit<Options, 'fromStart'> {
  color: string
}

export class SMAConfig extends BaseConfig {
  static type = OverlayType.Sma
  static abbreviation = 'sma'
  static label = 'Simple Moving Average'
  static shortLabel = 'SMA'
  static description =
    'The Simple Moving Average (SMA) is a basic technical indicator that calculates the average price of an asset over a specific number of periods. It smooths out price data to identify trends by averaging the closing prices. A rising SMA indicates an uptrend, while a falling SMA suggests a downtrend.'

  static optionsOrder = ['period'] as const
  static optionsLabels = { period: 'Period' }
  static inputsOrder = ['period', 'color'] as Array<keyof Attrs>
  static inputsLabels = { period: 'Period', color: 'Color' }
  static calculatedValuesOrder = ['sma'] as const
  static calculatedValuesLabels = { sma: 'SMA' }
  static defaultCalculatedValueOption = this.calculatedValuesOrder[0]
}
